var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home"}},[_c('intro'),_c('articles'),_c('about'),_c('articles2'),_c('about2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }